// Separate arrow function to update data and return the updated array
export const updateForumData = (oldArray, respondedArray) => {
  const updatedArray = [...oldArray]; // Create a copy of arrayOne to avoid modifying the original array

  for (let updatedResponse of respondedArray) {
    let editedId = updatedResponse._id;
    for (let i = 0; i < updatedArray.length; i++) {
      if (updatedArray[i]._id === editedId) {
        // Update data in the copied array
        updatedArray[i] = updatedResponse;
        break;
      }
    }
  }

  return updatedArray;
};
